import React from 'react'
import PropTypes from 'prop-types'

import { values } from 'lodash'

import classes from 'classnames'

import { ui } from '../redux'

export const Row = ({ children, className, ...otherProps }) => (
    <div className={ classes('row', className) } { ...otherProps }>
        { children }
    </div>
)

export const Column = ({ size, span, children, className }) => (
    <div className={ classes(`col-${size}-${span}`, className) }>
        { children }
    </div>
)

Column.propTypes = {
    size : PropTypes.oneOf(values(ui.SIZE)),
    span : PropTypes.number.isRequired
}

Column.defaultProps = {
    size: ui.SIZE.small
}

export default Column
